import { render, staticRenderFns } from "./extra-it-ticket-aufgeben.vue?vue&type=template&id=21ce02b2&scoped=true&lang=pug&"
import script from "./extra-it-ticket-aufgeben.vue?vue&type=script&lang=js&"
export * from "./extra-it-ticket-aufgeben.vue?vue&type=script&lang=js&"
import style0 from "./extra-it-ticket-aufgeben.vue?vue&type=style&index=0&id=21ce02b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce02b2",
  null
  
)

export default component.exports